import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '../src/store/store';

import { createBrowserHistory } from 'history';

import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { blue } from '@mui/material/colors';

import App from './containers/app/AppContainer';

import './style.scss';
import { AuthProvider } from './auth/useAuth';

const mountNode = document.getElementById('root');
export const history = createBrowserHistory();

const theme = createTheme({
  typography: {
      fontFamily: 'Roboto',
      fontWeight: '200 !important',
  },
  spacing: 8,
  palette: {
      primary: blue,
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: 'black',
        },
        arrow: {
          color: 'black',
        },
      },
    },
  },
});


// Used to make the React and Store available to fiddle with in Browser Console
// To be removed in Production Mode
// window.React = React;


// const onRedirectCallback = (appState) => {
//   history.push(
//     appState && appState.returnTo ? appState.returnTo : window.location.pathname
//   );
// };

const onRedirectCallback = (appState) => {
  // Use the router's history module to replace the url
  history.replace(appState?.returnTo || window.location.pathname);
};


// const authConfig = getConfig();
// const providerConfig = {
//   domain: authConfig.domain,
//   clientId: authConfig.clientId,
//   ...(authConfig.audience ? { audience: authConfig.audience } : null),
//   redirectUri: window.location.origin,
//   onRedirectCallback: onRedirectCallback,
// };


const root = ReactDOM.createRoot(mountNode);
root.render(
  <Suspense fallback={<div>Error! Please refresh the page</div>}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <Provider store={store}>
            <App />
          </Provider>
        </AuthProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </Suspense>
);